<template>
  <div
    :class="[ { activated: activated }, isLeft ? 'position-absolute' : 'position-relative h-100' ]"
    :style="{ marginRight: mx + 'px' }"
  >
    <bar-vect
      :num="num"
      :target="target"
      :w="barWidth"
      :h="isLeft ? winW * 0.8 : h"
      :style="{ transform: 'translateX(' + (-x) + 'px)' }"
      @transitionend.self="$event.propertyName === 'transform' ? $emit('transed') : null"
    />

    <percentage
      :num="percentNum"
      :label="label.title"
      :label-pos="label.pos"
      :align="label.align"
      :font-size="fontSize"
      :ind-override="indOverride"
      :style="[ { color: txtColor }, isLeft ? { bottom: percentNum + '%', top: 'auto' } : {} ]"
      v-if="!hidePercent"
    />

    <span
      class="adobe-clean d-flex align-items-center position-absolute bar-label"
      :style="{ height: barWidth + 'px' }"
      v-html="barLabel"
      v-if="barLabel"
    ></span>

  </div>
</template>

<script>
  import { TweenMax, Power1 } from 'gsap'
  import { dataTransTime } from '@/lib/consts'
  import { gradPtColor } from '@/lib/funcs'
  import GraphFragMixin from '@/components/report/mixins/GraphFragMixin'
  import StateMixin from '@/components/report/mixins/StateMixin'
  import BarVect from '@/components/svg/BarVect'

  export default {
    name: 'BarFragment',
    mixins: [ GraphFragMixin, StateMixin ],
    props: {
      barLabel: String,
      idx: Number,
      bg: { type: String, required: true },
      w: { type: Number, default () { return 125 } },
      h: { type: Number, default () { return 250 } },
      isLeft: { default () { return false } },
      transX: { default () { return 0 } },
      hidePercent: { default () { return false } },
      targetOverride: { default () { return null } }
    },
    data () {
      return { numOverride: this.active ? this.target : 0, activated: false, wOverride: null }
    },
    computed: {
      barWidth () {
        return this.wOverride || this.w
      },
      percentNum () {
        return this.targetOverride ? this.numOverride : this.num
      },
      mx () {
        return this.barWidth * -0.08
      },
      x () {
        return Math.max( 0, this.transX + this.mx )
      },
      txtColor () {
        return !this.isLeft ? '#fff' : gradPtColor( ...this.colors, 0.5 )
      }
    },
    watch: {
      targetOverride ( val ) {
        this.handleChange( val, dataTransTime, 'numOverride' )
      },
      active ( val ) {
        this.handleChange( val )
        this.handleChange( val, dataTransTime, 'numOverride' )
      }
    },
    methods: {
      handleChange ( val, time = dataTransTime, key = 'num' ) {
        TweenMax.to( this, time, {
          [ key ]: !val ? 0 : key === 'numOverride' ? this.targetOverride : this.target,
          ease: Power1.easeInOut,
          onStart: () => {
            if ( val === true ) this.activated = true
          },
          onComplete: () => {
            if ( val === true ) this.$emit( 'activated' )
          }
        } )
      }
    },
    mounted () {
      if ( !this.isSmall ) {
        this.wOverride = this.isLeft ? 105 : 200
      }
    },
    components: { BarVect }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/scss/global/the_goods";
  @import "~@/assets/scss/global/components/bars-common";

  .bar-wrap {

    .bar-label {
      left      : calc(100% + 7px);
      bottom    : 36px;
      transform : translateZ(100px) rotate(-90deg);
    }

    .align-bars-left & {
      .percentage-wrap {
        left      : -20px;
        width     : viewport-scale(115.41px);
        transform : rotate(-90deg) translateX(50%);

        .percent {
          margin-bottom : 0.12em;
        }
      }
    }

    &.in-carousel {
      $cube-bez : cubic-bezier(0, 0, 0.1, 1);

      .bar-vect {
        opacity    : 0.2;
        transition : opacity $cube-time $cube-bez;
      }

      &.on-active-slide .bar-vect {
        opacity : 1
      }

      &.looping .bar-vect {
        transition : opacity $cube-time $cube-bez, transform $cube-time $cube-bez;
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/report/content/BarFragment.vue